export const FEATURE_CLUBHOUSE_NEWS = 'clubhouse-news'
export const FEATURE_CLUBHOUSE_STORE = 'clubhouse-store'
export const FEATURE_CLUBHOUSE_TRENDS = 'clubhouse-trends'
export const FEATURE_CLUBHOUSE_ENABLED_KNOWLEDGE_HUBS = 'clubhouse-enabled-knowledge-hubs'
export const FEATURE_CLUBHOUSES_CLASSES = 'clubhouses-classes'
export const FEATURE_CLUBHOUSES_DISCOVER_DESIGNERS = 'clubhouses-discover-designers'
export const FEATURE_CLUBHOUSES_EVENTS = 'clubhouses-events'
export const FEATURE_CLUBHOUSES_FILE_SHARING = 'clubhouses-file-sharing'
export const FEATURE_CLUBHOUSES_GROUPS = 'clubhouses-groups'
export const FEATURE_CLUBHOUSES_INVITE_MEMBERS = 'clubhouses-invite-members'
export const FEATURE_CLUBHOUSES_TRUSTED_VENDORS = 'clubhouses-trusted-vendors'
export const FEATURE_CLUBHOUSES_TUTORIALS = 'clubhouses-tutorials'
export const FEATURE_CLUBHOUSES_YOUR_CLUB = 'clubhouses-your-club'
export const FEATURE_CLUBHOUSES_QUIZZES = 'clubhouses-quizzes-array'
export const FEATURE_CLUBHOUSES_LEADERS = 'clubhouses-leaders'
export const FEATURE_CLUBHOUSES_HEADER_COUNT = 'clubhouses-header-count'
export const FEATURE_CLUBHOUSES_CRAFTER_TAB = 'clubhouse-crafter-tab'
export const FEATURE_CLUBHOUSES_QUIZZ_PROFILE_LEADERBOARD = 'clubhouse-quizz-profile-leaderboard'
export const FEATURE_CLUBHOUSES_QUIZ_ADD_BADGE_TO_PROFILE = 'clubhouses-quiz-add-badge-to-profile'
export const FEATURE_CLUBHOUSES_QUIZ_YOUR_BADGES_AND_AWARDS =
  'clubhouses-quiz-your-badges-and-awards'
export const FEATURE_CLUBHOUSES_QUIZ_RANKING = 'clubhouses-quiz-ranking'
export const FEATURE_CLUBHOUSES_BIRTHDAY_SECTION = 'clubhouse-birthday-section'
export const FEATURE_CLUBHOUSES_DISCUSSIONS_RELATED = 'clubhouses-discussions-related'
export const FEATURE_CLUBHOUSES_DISCUSSIONS_BOOKMARK = 'clubhouses-discussions-bookmark'
export const FEATURE_CLUBHOUSES_DISCUSSIONS_DELETE = 'clubhouses-discussions-delete'
export const FEATURE_CLUBHOUSES_SEARCH_SELECT = 'clubhouses-search-select'
export const FEATURE_CLUBHOUSES_NOTIFICATIONS_SETTINGS = 'clubhouse-notifications-settings'
export const FEATURE_CLUBHOUSE_SHOW_JOIN_MODAL = 'clubhouse-join-modal-non-logged-in-member'
export const FEATURE_CLUBHOUSE_GETTING_STARTED = 'clubhouse-enabled-getting-started-page'
export const FEATURE_CLUBHOUSES_PROJECTS = 'soc-2292-masterfeed-v2'
